import React, {Component} from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik, Field, FieldArray} from 'formik';
import _ from 'lodash';
import config from '../config';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";

export default class Event extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        let {id} = this.props.match.params;
        this.state = {
            encodedId: id,
            id: decodeURIComponent(id)
        }
        this.init = this.init.bind(this);
        this.addUser = this.addUser.bind(this);
        this.removeUser = this.removeUser.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    async init() {
        let responseItems = await fetcher(`${config.API()}leaderboards/get/${encodeURIComponent(this.state.encodedId)}`);
        let resp = await responseItems.json();
        this.setState({
            items: resp.items
        })
    }
    removeUser = (userId) => {
        return async (e) => {
            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;
            await fetcher(`${config.API()}leaderboards/remove/user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userId: parseInt(userId),
                    leaderboardId: this.state.id,
                })
            })
            this.init();
        }
    }

    async addUser(values) {
        await fetcher(`${config.API()}leaderboards/add/scores`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: values.userId,
                scores: values.scores,
                leaderboardId: this.state.id,
            })
        })
        this.init();
    }

    timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    render() {
        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3">
                        <h2 className="m-0 font-weight-bold l"> Leaderboard {this.state.id}</h2>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                                   cellSpacing="0">
                                <thead>
                                <tr>
                                    <th>UserId</th>
                                    <th>Name</th>
                                    <th>Level</th>
                                    <th>Country</th>
                                    <th>Position</th>
                                    <th>Score</th>
                                    <th>LastLogin</th>
                                    <th>Bot</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.items && this.state.items.map((x, i) =>
                                    <tr key={x.userId}>
                                        <td>{x.userId}</td>
                                        <td>{x.name}</td>
                                        <td>{x.level}</td>
                                        <td>{x.country}</td>
                                        <td>{x.ratingPosition}</td>
                                        <td>{x.ratingScore}</td>
                                        <td>{x.lastLogin}</td>
                                        <td>{x.bot ? "true": "false"}</td>
                                        <td><button className="btn btn-outline-danger btn-circle btn-sm" onClick={this.removeUser(x.userId)} ><i className="fa fa-remove"></i></button></td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                        <Formik initialValues={{}} onSubmit={this.addUser}>
                            {({
                                  values,
                                  handleSubmit,
                                  handleChange,
                                  setFieldValue,
                                  isSubmitting
                              }) => (
                                <div className="card shadow w100">
                                    <div className="card-header py-3">
                                        <h2 className="m-0 font-weight-bold l"> Add scores to user</h2>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group row">
                                                <label className="col-sm-2 col-form-label">UserId</label>
                                                <div className="col-sm-10">
                                                    <input className="form-control" type="number" name="userId" onChange={handleChange} value={values.userId}/>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-2 col-form-label">Scores</label>
                                                <div className="col-sm-10">
                                                    <input className="form-control" type="number" name="scores" onChange={handleChange} value={values.scores}/>
                                                </div>
                                            </div>

                                            <button type="submit" className="btn btn-icon btn-success ml-1 r"><span className="fas fa-fw fa-save"></span>Add</button>
                                        </form>
                                    </div>
                                </div>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }
}